import React from "react";
import Lottie from "lottie-react";
import splashAnimation from "../../assets/lottie/splashAnimation";
import "./GlobalLoader.scss";

// Unified loading experience.
//   <GlobalLoader />                          → full-viewport splash
//   <GlobalLoader inline />                   → embedded inside a section
//   <GlobalLoader inline compact />           → very small (button spinner)
//   <GlobalLoader label="Loading posts" />    → custom caption
//
// Uses the exact `splashAnimation` lottie from portfolio.js so the experience
// matches the initial site-load splash screen.

const GlobalLoader = ({
  label = "Rashid Ahmad",
  inline = false,
  compact = false,
}) => {
  const className =
    "rd-gloader" +
    (inline ? " rd-gloader--inline" : "") +
    (compact ? " rd-gloader--compact" : "");

  return (
    <div className={className} role="status" aria-live="polite" aria-busy="true">
      <div className="rd-gloader__lottie" aria-hidden="true">
        <Lottie animationData={splashAnimation} loop autoplay />
      </div>
      {!compact && <div className="rd-gloader__label">{label}</div>}
      <span className="rd-gloader__sr">Loading {label}…</span>
    </div>
  );
};

export default GlobalLoader;
